const getStep1Status = (stepsValidity: Record<number, boolean>, stepInEdit?: number): string => 
    stepInEdit===1 && 'active' || stepsValidity['1'] && 'done-open' || 'active';

const getStep2Status = (stepsValidity: Record<number, boolean>, stepInEdit?: number): string => 
    (stepInEdit===2 || (!stepInEdit && stepsValidity['1'] && !stepsValidity['2'])) && 'active' || stepsValidity['2'] && 'done-open' || 'default';

const getStep3Status = (stepsValidity: Record<number, boolean>, stepInEdit?: number): string => 
    (stepInEdit===3 || (!stepInEdit && stepsValidity['1'] && stepsValidity['2'] && !stepsValidity['3'])) && 'active' || stepsValidity['3'] && 'done-open' || 'default';

const getStep4Status = (stepsValidity: Record<number, boolean>, stepInEdit?: number): string => 
    (stepInEdit===4 || (!stepInEdit && stepsValidity['1'] && stepsValidity['2'] && stepsValidity['3'] && !stepsValidity['4'])) && 'active' || stepsValidity['4'] && 'done-open' || 'default';

const getStep5Status = (stepsValidity: Record<number, boolean>, stepInEdit?: number): string => 
    (stepInEdit===5 || (!stepInEdit && stepsValidity['1'] && stepsValidity['2'] && stepsValidity['3'] && stepsValidity['4'] && !stepsValidity['5'])) && 'active' || stepsValidity['5'] && 'done-open' || 'default';

export const getStepsStatuses = (stepsValidity: Record<number, boolean>, stepInEdit?: number): Record<number, string> => ({
    1: getStep1Status(stepsValidity, stepInEdit),
    2: getStep2Status(stepsValidity, stepInEdit),
    3: getStep3Status(stepsValidity, stepInEdit),
    4: getStep4Status(stepsValidity, stepInEdit),
    5: getStep5Status(stepsValidity, stepInEdit),
});
